import React from 'react';

const MinusIcon = () => <>&ndash;</>;

export default MinusIcon;
